import React from 'react';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

// Estilos aplicados a Link en vez de <a>
const StyledLink = styled(Link)(
  ({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) => ({
    borderRadius: '50rem',
    background: 'linear-gradient(-90deg, rgba(218, 218, 218, 0.9), rgb(196, 196, 196, 0.9))',
    color: '#0A6274',
    fontWeight: 'bold',
    fontSize: '16px',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
    position: 'relative',
    cursor: 'pointer',
    zIndex: 1,
    padding: '8px 10px',

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      padding: '1px',
      borderRadius: '50rem',
      background:
        'linear-gradient(90deg,rgba(194, 194, 194, 0.5), rgba(124, 124, 124, 0))',
      WebkitMask:
        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
      zIndex: -1,
      transition: 'opacity 0.3s ease',
    },

    '&:hover': {
      boxShadow:
        '0px -1px 3px rgba(228, 228, 228, 0.3), 0px 2px 10px rgba(219, 219, 219, 0.5)',
      background:
        'linear-gradient(-90deg, rgb(241, 241, 241), rgb(226, 225, 225))',
      '&::before': {
        background:
          'linear-gradient(90deg,rgb(218, 218, 218), rgba(124, 124, 124, 0))',
      },
    },

    '&:active': {
      boxShadow: 'inset 3px 3px 5px rgba(0,0,0,0.2)',
      background: 'linear-gradient(-90deg, rgba(218, 218, 218, 0.8), rgb(196, 196, 196, 0.8))',
    },
  })
);

type WhiteButtonProps = {
  href: string;
  size?: 'sm' | 'md' | 'lg';
};

const WhiteButtonComponent: React.FC<WhiteButtonProps> = ({
  href,
  size = 'md',
}) => {
  return (
    <StyledLink to={href} size={size}>
      ¡Contáctanos!
    </StyledLink>
  );
};

export default WhiteButtonComponent;
